import 'antd/dist/reset.css';
import '../../index.css';
import './index.css';

import {navigate, withPrefix} from 'gatsby';
import PropTypes from 'prop-types';
import React, {useEffect, useState} from 'react';
import {Helmet} from 'react-helmet';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import styled from 'styled-components';
import Modal from '../../Modals';
import {isNoLayoutPath} from '../../Utils/noLayoutPaths';
import {normalizePath} from '../../Utils/pathUtil';
import ContactUsButton from '../ContactUsButton';
import Footer from '../Footer';
import Navbar from '../Navbar';
import Delighters from '../ReactDelighters';
import Toast from '../Toast';
import ScrollToTopButton from '../ScrollToTopButton';
const appConfig = require('../../data.json');

const Layout = ({location, children, seo}) => {
  const _pathname = normalizePath(location.pathname);
  const extraHeadMetaArray = appConfig['extra-head-meta'] || [];

  React.useLayoutEffect(() => {
    if (appConfig.maintenance && location.pathname !== '/maintenance/') {
      navigate('/maintenance/');
    }
  }, [location]);

  React.useLayoutEffect(() => {
    // ga4 initial
    if (typeof window !== 'undefined') {
      window.dataLayer = window.dataLayer || [];
      window.gtag = function () {
        window.dataLayer.push(arguments);
      };
      window.gtag('js', new Date());
      window.gtag('config', appConfig.googleAnalyticsId, {
        page_path: location.pathname,
        debug_mode: appConfig.debug,
      });
    }
  }, [location]);

  useEffect(() => {
    if (appConfig.enableGetButton && appConfig.getButtonId) {
      const scriptId = 'getbutton-script';
      // 檢查 script 是否已存在
      if (!document.getElementById(scriptId)) {
        const script = document.createElement('script');
        script.id = scriptId;
        script.src = `https://static.getbutton.io/widget/bundle.js?id=${appConfig.getButtonId}`;

        setTimeout(() => {
          document.body.appendChild(script);
        }, 3000);
      }
    }

    // 清理函數
    return () => {
      const scriptElement = document.getElementById('getbutton-script');
      if (scriptElement) {
        scriptElement.remove();
      }
    };
  }, []);

  // 是否為不套 Layout 的頁面（編輯器等）。
  // 白牌調整：原本硬編碼比對 '/designs/' 與 '/business/'，改為讀
  // src/Utils/noLayoutPaths.js 的單一來源——該清單已依 config.enableEditor
  // 決定，且 gatsby-browser / gatsby-ssr 的 wrapPageElement 用的是同一支判斷。
  const shouldShowLayout = !isNoLayoutPath(location.pathname);

  return (
    <main>
      <Helmet>
        {/* <link rel="shortcut icon" href="/favicon.ico" /> */}
        <title>{seo.title || appConfig.information.name}</title>
        {seo.keywords && <meta name="keywords" content={seo.keywords} />}

        {seo.ogTitle && <meta property="og:title" content={seo.ogTitle} />}
        {seo.description && (
          <meta name="description" content={seo.description} />
        )}
        {seo.image && <meta name="image" content={seo.image} />}
        {seo.ogDescription && (
          <meta property="og:description" content={seo.ogDescription} />
        )}
        {seo.image && <meta property="og:image" content={seo.image} />}

        {extraHeadMetaArray.map((m, idx) => (
          <meta key={idx} {...m} />
        ))}

        {appConfig.googleSiteVerification !== '' && (
          <meta
            name="google-site-verification"
            content={appConfig.googleSiteVerification}
          />
        )}

        <meta name="author" content="EcultureTech 奕果雲端數位股份有限公司" />

        {/* 白牌調整：原本以平台名硬編碼（['lixiang-dev','lixiang-staging']），
            白牌站的 name 不在該清單內會意外變成可收錄，故改為 config 驅動。 */}
        {appConfig.noindex && (
          <meta name="robots" content="noindex, nofollow" />
        )}

        <script src={'/yahoo-ad-tracking.js'} type="application/javascript" />
        {/* 統一金流 PAYUNi SDK。
            🔴 白牌調整：原本同樣以平台名硬編碼決定 sandbox / 正式——白牌站的 name
            不在清單內會落到 else 分支、載入「正式環境」SDK 打真實金流。
            改由 config.payuniSandbox 決定（demo 與 std 皆預設 true）。
            src/Components/Checkout/PaymentInfo.js 的 SDK env 參數讀同一個開關。 */}
        <script
          src={
            appConfig.payuniSandbox
              ? 'https://sandbox-vendor.payuni.com.tw/sdk/uni-payment.js'
              : 'https://vendor.payuni.com.tw/sdk/uni-payment.js'
          }></script>
        <script
          async
          src={`https://www.googletagmanager.com/gtag/js?id=${appConfig.googleAnalyticsId}`}
        />
      </Helmet>
      <Delighters>
        <Content>
          {shouldShowLayout && <Navbar pathname={_pathname} />}
          <div
            style={{
              flex: 1,
              position: 'relative',
              minHeight: '70vh',
              display: 'flex',
              flexDirection: 'column',
            }}>
            {children}
          </div>
          {shouldShowLayout && <Footer />}
        </Content>
      </Delighters>
      <Toast />
      <Modal />

      <ContactUsButton location={location} />
      <ScrollToTopButton />
    </main>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

const Content = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: stretch;
`;

export default Layout;
